var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBeyondStayCheckin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_167",
    "data-name": "Rectangle 167",
    width: 60,
    height: 60,
    rx: 11,
    transform: "translate(510 475)",
    fill: "#5d44ff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_111",
    "data-name": "Rectangle 111",
    width: 86.062,
    height: 70.355,
    transform: "translate(0 0)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_163",
    "data-name": "Rectangle 163",
    width: 30.345,
    height: 60,
    transform: "translate(20.789 0)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_166",
    "data-name": "Rectangle 166",
    d: "M3.461,0H56.539A3.46,3.46,0,0,1,60,3.46V56.54A3.46,3.46,0,0,1,56.539,60H3.461A3.461,3.461,0,0,1,0,56.539V3.461A3.461,3.461,0,0,1,3.461,0Z",
    transform: "translate(20.789 0)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_127",
    "data-name": "Group 127",
    transform: "translate(-862 -697)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_4",
    "data-name": "Mask Group 4",
    transform: "translate(352 222)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32",
    "data-name": "Group 32",
    transform: "translate(490 475)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27",
    "data-name": "Group 27"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26",
    "data-name": "Group 26",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_100",
    "data-name": "Path 100",
    d: "M77.328,60H24.249a3.461,3.461,0,0,1-3.461-3.46V3.46A3.461,3.461,0,0,1,24.249,0H77.328a3.46,3.46,0,0,1,3.46,3.46V56.54A3.46,3.46,0,0,1,77.328,60",
    fill: "#5d44ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_101",
    "data-name": "Path 101",
    d: "M77.1,6.095a4.3,4.3,0,1,1-4.3-4.3,4.3,4.3,0,0,1,4.3,4.3",
    fill: "#fff0bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102",
    "data-name": "Path 102",
    d: "M64.167,11.037H77.976s-.593-2.9-3.965-1.495c0,0-7.729-5.968-9.844,1.495",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_29",
    "data-name": "Group 29"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28",
    "data-name": "Group 28",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_112",
    "data-name": "Rectangle 112",
    width: 12.638,
    height: 3.929,
    transform: "translate(37.562 17.938)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_113",
    "data-name": "Rectangle 113",
    width: 10.992,
    height: 0.702,
    transform: "translate(37.563 21.867)",
    fill: "#c9c9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_103",
    "data-name": "Path 103",
    d: "M29.583,6.168a5.083,5.083,0,0,0-8.96,0H15.9V9.342H34.3V6.168Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_114",
    "data-name": "Rectangle 114",
    width: 27.042,
    height: 3.501,
    transform: "translate(11.637 10.109)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_115",
    "data-name": "Rectangle 115",
    width: 24.924,
    height: 39.316,
    transform: "translate(12.639 13.61)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_116",
    "data-name": "Rectangle 116",
    width: 27.042,
    height: 1.533,
    transform: "translate(11.637 8.576)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_117",
    "data-name": "Rectangle 117",
    width: 46.908,
    height: 30.228,
    transform: "translate(1.646 22.569)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_118",
    "data-name": "Rectangle 118",
    width: 2.527,
    height: 3.661,
    transform: "translate(24.035 39.106)",
    fill: "#e3dbd8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_119",
    "data-name": "Rectangle 119",
    width: 1.913,
    height: 3.047,
    transform: "translate(24.342 39.413)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_120",
    "data-name": "Rectangle 120",
    width: 2.331,
    height: 0.2,
    transform: "translate(24.158 40.285)",
    fill: "#e3dbd8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_121",
    "data-name": "Rectangle 121",
    width: 2.527,
    height: 3.661,
    transform: "translate(24.035 33.595)",
    fill: "#e3dbd8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_122",
    "data-name": "Rectangle 122",
    width: 1.913,
    height: 3.047,
    transform: "translate(24.342 33.902)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_123",
    "data-name": "Rectangle 123",
    width: 2.331,
    height: 0.2,
    transform: "translate(24.158 34.774)",
    fill: "#e3dbd8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_124",
    "data-name": "Rectangle 124",
    width: 2.527,
    height: 3.661,
    transform: "translate(24.035 28.083)",
    fill: "#e3dbd8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_125",
    "data-name": "Rectangle 125",
    width: 1.913,
    height: 3.047,
    transform: "translate(24.342 28.39)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_126",
    "data-name": "Rectangle 126",
    width: 2.331,
    height: 0.2,
    transform: "translate(24.158 29.263)",
    fill: "#e3dbd8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_127",
    "data-name": "Rectangle 127",
    width: 2.527,
    height: 3.661,
    transform: "translate(24.035 22.572)",
    fill: "#e3dbd8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_128",
    "data-name": "Rectangle 128",
    width: 1.913,
    height: 3.047,
    transform: "translate(24.342 22.879)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_129",
    "data-name": "Rectangle 129",
    width: 2.331,
    height: 0.2,
    transform: "translate(24.158 23.751)",
    fill: "#e3dbd8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_130",
    "data-name": "Rectangle 130",
    width: 2.527,
    height: 3.661,
    transform: "translate(24.035 17.061)",
    fill: "#e3dbd8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_131",
    "data-name": "Rectangle 131",
    width: 1.913,
    height: 3.047,
    transform: "translate(24.342 17.368)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_132",
    "data-name": "Rectangle 132",
    width: 2.331,
    height: 0.2,
    transform: "translate(24.158 18.24)",
    fill: "#e3dbd8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_133",
    "data-name": "Rectangle 133",
    width: 2.527,
    height: 3.661,
    transform: "translate(31.805 39.106)",
    fill: "#e3dbd8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_134",
    "data-name": "Rectangle 134",
    width: 1.913,
    height: 3.047,
    transform: "translate(32.112 39.413)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_135",
    "data-name": "Rectangle 135",
    width: 2.332,
    height: 0.2,
    transform: "translate(31.927 40.285)",
    fill: "#e3dbd8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_136",
    "data-name": "Rectangle 136",
    width: 2.527,
    height: 3.661,
    transform: "translate(42.618 39.106)",
    fill: "#e3dbd8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_137",
    "data-name": "Rectangle 137",
    width: 1.913,
    height: 3.047,
    transform: "translate(42.925 39.413)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_138",
    "data-name": "Rectangle 138",
    width: 2.332,
    height: 0.2,
    transform: "translate(42.741 40.285)",
    fill: "#e3dbd8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_139",
    "data-name": "Rectangle 139",
    width: 2.527,
    height: 3.661,
    transform: "translate(42.618 33.595)",
    fill: "#e3dbd8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_140",
    "data-name": "Rectangle 140",
    width: 1.913,
    height: 3.047,
    transform: "translate(42.925 33.902)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_141",
    "data-name": "Rectangle 141",
    width: 2.332,
    height: 0.2,
    transform: "translate(42.741 34.774)",
    fill: "#e3dbd8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_142",
    "data-name": "Rectangle 142",
    width: 2.527,
    height: 3.661,
    transform: "translate(42.618 28.083)",
    fill: "#e3dbd8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_143",
    "data-name": "Rectangle 143",
    width: 1.913,
    height: 3.047,
    transform: "translate(42.925 28.39)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_144",
    "data-name": "Rectangle 144",
    width: 2.332,
    height: 0.2,
    transform: "translate(42.741 29.263)",
    fill: "#e3dbd8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_145",
    "data-name": "Rectangle 145",
    width: 2.527,
    height: 3.661,
    transform: "translate(31.805 33.595)",
    fill: "#e3dbd8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_146",
    "data-name": "Rectangle 146",
    width: 1.913,
    height: 3.047,
    transform: "translate(32.112 33.902)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147",
    "data-name": "Rectangle 147",
    width: 2.332,
    height: 0.2,
    transform: "translate(31.927 34.774)",
    fill: "#e3dbd8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148",
    "data-name": "Rectangle 148",
    width: 2.527,
    height: 3.661,
    transform: "translate(31.805 28.083)",
    fill: "#e3dbd8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_149",
    "data-name": "Rectangle 149",
    width: 1.913,
    height: 3.047,
    transform: "translate(32.112 28.39)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_150",
    "data-name": "Rectangle 150",
    width: 2.332,
    height: 0.2,
    transform: "translate(31.927 29.263)",
    fill: "#e3dbd8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_151",
    "data-name": "Rectangle 151",
    width: 2.527,
    height: 3.661,
    transform: "translate(31.805 22.572)",
    fill: "#e3dbd8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_152",
    "data-name": "Rectangle 152",
    width: 1.913,
    height: 3.047,
    transform: "translate(32.112 22.879)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_153",
    "data-name": "Rectangle 153",
    width: 2.332,
    height: 0.2,
    transform: "translate(31.927 23.751)",
    fill: "#e3dbd8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_154",
    "data-name": "Rectangle 154",
    width: 2.527,
    height: 3.661,
    transform: "translate(31.805 17.061)",
    fill: "#e3dbd8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_155",
    "data-name": "Rectangle 155",
    width: 1.913,
    height: 3.047,
    transform: "translate(32.112 17.368)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_156",
    "data-name": "Rectangle 156",
    width: 2.332,
    height: 0.2,
    transform: "translate(31.927 18.24)",
    fill: "#e3dbd8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_157",
    "data-name": "Rectangle 157",
    width: 24.924,
    height: 0.78,
    transform: "translate(12.639 13.61)",
    fill: "#c9c9c9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_158",
    "data-name": "Rectangle 158",
    width: 1.569,
    height: 30.228,
    transform: "translate(37.563 22.569)",
    fill: "#c9c9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_104",
    "data-name": "Path 104",
    d: "M26.7,45.556a1.813,1.813,0,0,0-3.2,0H21.82v7.37h6.56v-7.37Z",
    fill: "#d9e3d9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_159",
    "data-name": "Rectangle 159",
    width: 12.638,
    height: 3.929,
    transform: "translate(37.588 48.983)",
    fill: "#c9c9c9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_160",
    "data-name": "Rectangle 160",
    width: 5.48,
    height: 6.537,
    transform: "translate(22.39 46.379)",
    fill: "#c9c9c9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_161",
    "data-name": "Rectangle 161",
    width: 18.203,
    height: 0.623,
    transform: "translate(16.074 7.902)",
    fill: "#c9c9c9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_162",
    "data-name": "Rectangle 162",
    width: 0.542,
    height: 12.054,
    transform: "translate(33.712 47.946)",
    fill: "#5d44ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_105",
    "data-name": "Path 105",
    d: "M46.727,48.11H33.711V44.136H46.727l1.267,1.987Z",
    fill: "#5d44ff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_31",
    "data-name": "Group 31"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_30",
    "data-name": "Group 30",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_106",
    "data-name": "Path 106",
    d: "M83.764,59.724H51.738a.647.647,0,0,1-.647-.647v-.272h33.32v.272a.647.647,0,0,1-.647.647",
    fill: "#5d6060"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_107",
    "data-name": "Path 107",
    d: "M80.935,53.732H54.568l-3.477,5.073h33.32Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108",
    "data-name": "Path 108",
    d: "M80.481,37.007H55.021a.44.44,0,0,0-.44.441V53.732H80.922V37.448a.441.441,0,0,0-.441-.441",
    fill: "#5d6060"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_164",
    "data-name": "Rectangle 164",
    width: 24.729,
    height: 14.041,
    transform: "translate(55.387 38.394)",
    fill: "#e3ebe4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_109",
    "data-name": "Path 109",
    d: "M83.764,59.788H51.738a.711.711,0,0,1-.71-.71v-.273a.063.063,0,0,1,.063-.063h33.32a.064.064,0,0,1,.064.063v.273a.712.712,0,0,1-.711.71m-32.609-.919v.209a.584.584,0,0,0,.583.583H83.764a.584.584,0,0,0,.583-.583v-.209Z",
    fill: "#5d6060"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110",
    "data-name": "Path 110",
    d: "M84.411,58.868H51.091a.064.064,0,0,1-.056-.034.061.061,0,0,1,0-.065L54.515,53.7a.062.062,0,0,1,.052-.028H80.935a.062.062,0,0,1,.052.028l3.476,5.073a.061.061,0,0,1,0,.065.063.063,0,0,1-.056.034m-33.2-.127H84.29L80.9,53.795H54.6Z",
    fill: "#5d6060"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111",
    "data-name": "Path 111",
    d: "M80.922,53.795H54.581a.063.063,0,0,1-.063-.063V37.447a.5.5,0,0,1,.5-.5h25.46a.5.5,0,0,1,.5.5V53.732a.064.064,0,0,1-.064.063m-26.277-.127H80.859V37.447a.378.378,0,0,0-.377-.376H55.022a.377.377,0,0,0-.377.376Z",
    fill: "#5d6060"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_112",
    "data-name": "Path 112",
    d: "M80.116,52.5H55.387a.064.064,0,0,1-.064-.064V38.394a.064.064,0,0,1,.064-.064H80.116a.064.064,0,0,1,.063.064V52.435a.064.064,0,0,1-.063.064m-24.665-.128h24.6V38.457h-24.6Z",
    fill: "#5d6060"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_165",
    "data-name": "Rectangle 165",
    width: 13.549,
    height: 0.615,
    transform: "translate(60.977 53.016)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_113",
    "data-name": "Path 113",
    d: "M66.6,37.685a.415.415,0,1,1-.415-.415.415.415,0,0,1,.415.415",
    fill: "#e3ebe4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_114",
    "data-name": "Path 114",
    d: "M72.529,58.458H62.973a.064.064,0,0,1-.056-.034.061.061,0,0,1,0-.065l1-1.455a.063.063,0,0,1,.052-.028h7.562a.066.066,0,0,1,.053.028l1,1.455a.061.061,0,0,1,0,.065.064.064,0,0,1-.056.034m-9.435-.127h9.314L71.5,57H64Z",
    fill: "#5d6060"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_115",
    "data-name": "Path 115",
    d: "M58.023,55.092H56.261a.066.066,0,0,1-.055-.031.064.064,0,0,1,0-.063l.452-.805a.063.063,0,0,1,.055-.033h1.693a.062.062,0,0,1,.054.03.063.063,0,0,1,0,.061l-.383.805a.064.064,0,0,1-.058.036m-1.653-.127h1.613l.323-.678H56.751Z",
    fill: "#5d6060"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_116",
    "data-name": "Path 116",
    d: "M61.066,55.092H59.3a.062.062,0,0,1-.053-.028.064.064,0,0,1-.006-.06l.333-.805a.065.065,0,0,1,.059-.039H61.33a.064.064,0,0,1,.051.026.063.063,0,0,1,.009.058l-.264.805a.062.062,0,0,1-.06.043M59.4,54.965H61.02l.222-.678H59.679Z",
    fill: "#5d6060"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117",
    "data-name": "Path 117",
    d: "M64.108,55.092H62.346a.062.062,0,0,1-.05-.025.063.063,0,0,1-.011-.055l.213-.805a.065.065,0,0,1,.062-.047h1.693a.062.062,0,0,1,.049.023.06.06,0,0,1,.013.052l-.144.805a.063.063,0,0,1-.063.052m-1.679-.127h1.626l.122-.678H62.609Z",
    fill: "#5d6060"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_118",
    "data-name": "Path 118",
    d: "M67.151,55.092H65.388a.062.062,0,0,1-.047-.021.065.065,0,0,1-.015-.05l.094-.805a.064.064,0,0,1,.063-.056h1.693a.061.061,0,0,1,.046.02.065.065,0,0,1,.018.046l-.025.8a.063.063,0,0,1-.064.061m-1.69-.127H67.09l.02-.678H65.539Z",
    fill: "#5d6060"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119",
    "data-name": "Path 119",
    d: "M70.194,55.092H68.431a.063.063,0,0,1-.063-.061l-.025-.8a.064.064,0,0,1,.017-.047.066.066,0,0,1,.046-.019H70.1a.064.064,0,0,1,.064.056l.094.805a.066.066,0,0,1-.016.05.061.061,0,0,1-.047.021m-1.7-.127h1.629l-.079-.678H68.472Z",
    fill: "#5d6060"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_120",
    "data-name": "Path 120",
    d: "M73.236,55.092H71.474a.063.063,0,0,1-.063-.052l-.144-.805a.06.06,0,0,1,.013-.052.064.064,0,0,1,.049-.023h1.693a.065.065,0,0,1,.062.047l.213.805a.063.063,0,0,1-.011.055.062.062,0,0,1-.05.025m-1.709-.127h1.626l-.18-.678H71.4Z",
    fill: "#5d6060"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_121",
    "data-name": "Path 121",
    d: "M76.279,55.092H74.517a.064.064,0,0,1-.061-.043l-.263-.805a.063.063,0,0,1,.009-.058.064.064,0,0,1,.051-.026h1.693A.065.065,0,0,1,76,54.2l.333.805a.064.064,0,0,1-.006.06.063.063,0,0,1-.053.028m-1.716-.127h1.621l-.28-.678H74.341Z",
    fill: "#5d6060"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122",
    "data-name": "Path 122",
    d: "M79.321,55.092H77.559a.064.064,0,0,1-.058-.036l-.383-.805a.064.064,0,0,1,.058-.091h1.693a.063.063,0,0,1,.055.033l.453.805a.064.064,0,0,1,0,.063.063.063,0,0,1-.055.031M77.6,54.965h1.613l-.38-.678H77.277Z",
    fill: "#5d6060"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123",
    "data-name": "Path 123",
    d: "M56.116,56.221H54.354a.066.066,0,0,1-.055-.031.064.064,0,0,1,0-.063l.452-.805a.063.063,0,0,1,.055-.033H56.5a.062.062,0,0,1,.054.03.063.063,0,0,1,0,.061l-.383.805a.064.064,0,0,1-.058.036m-1.653-.127h1.613l.323-.678H54.844Z",
    fill: "#5d6060"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_124",
    "data-name": "Path 124",
    d: "M59.159,56.221H57.4a.062.062,0,0,1-.053-.028.064.064,0,0,1-.006-.06l.333-.805a.065.065,0,0,1,.059-.039h1.693a.064.064,0,0,1,.051.026.063.063,0,0,1,.009.058l-.264.8a.062.062,0,0,1-.06.044m-1.667-.127h1.621l.222-.678H57.772Z",
    fill: "#5d6060"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_125",
    "data-name": "Path 125",
    d: "M62.2,56.221H60.439a.062.062,0,0,1-.05-.025.063.063,0,0,1-.011-.055l.213-.805a.065.065,0,0,1,.062-.047h1.693a.062.062,0,0,1,.049.023.06.06,0,0,1,.013.052l-.144.805a.063.063,0,0,1-.063.052m-1.679-.127h1.626l.122-.678H60.7Z",
    fill: "#5d6060"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_126",
    "data-name": "Path 126",
    d: "M65.244,56.221H63.481a.062.062,0,0,1-.047-.021.075.075,0,0,1-.016-.05l.1-.805a.062.062,0,0,1,.063-.056H65.27a.063.063,0,0,1,.044.019.065.065,0,0,1,.018.047l-.025.805a.063.063,0,0,1-.063.061m-1.69-.127h1.628l.021-.678H63.632Z",
    fill: "#5d6060"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_127",
    "data-name": "Path 127",
    d: "M68.286,56.221H66.524a.063.063,0,0,1-.063-.061l-.025-.805a.064.064,0,0,1,.017-.047.066.066,0,0,1,.046-.019h1.693a.062.062,0,0,1,.063.056l.1.805a.066.066,0,0,1-.016.05.061.061,0,0,1-.048.021m-1.7-.127h1.629l-.079-.678H66.565Z",
    fill: "#5d6060"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_128",
    "data-name": "Path 128",
    d: "M71.329,56.221H69.567a.064.064,0,0,1-.063-.052l-.144-.805a.06.06,0,0,1,.013-.052.064.064,0,0,1,.049-.023h1.693a.064.064,0,0,1,.062.047l.213.805a.066.066,0,0,1-.011.056.064.064,0,0,1-.05.024m-1.709-.127h1.626l-.18-.678H69.5Z",
    fill: "#5d6060"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_129",
    "data-name": "Path 129",
    d: "M74.372,56.221H72.61a.063.063,0,0,1-.061-.044l-.263-.8a.063.063,0,0,1,.06-.084h1.693a.065.065,0,0,1,.059.039l.333.805a.064.064,0,0,1-.006.06.063.063,0,0,1-.053.028m-1.716-.127h1.621L74,55.416H72.434Z",
    fill: "#5d6060"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_130",
    "data-name": "Path 130",
    d: "M77.414,56.221H75.652a.064.064,0,0,1-.058-.036l-.383-.805a.064.064,0,0,1,.058-.091h1.693a.063.063,0,0,1,.055.033l.452.805a.063.063,0,0,1-.055.094m-1.722-.127h1.613l-.38-.678H75.37Z",
    fill: "#5d6060"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_131",
    "data-name": "Path 131",
    d: "M80.394,56.221H78.632a.064.064,0,0,1-.058-.036l-.383-.805a.064.064,0,0,1,.058-.091h1.693a.063.063,0,0,1,.055.033l.452.805a.063.063,0,0,1-.055.094m-1.722-.127h1.613l-.38-.678H78.35Z",
    fill: "#5d6060"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_132",
    "data-name": "Path 132",
    d: "M70,47.323H61.146a.518.518,0,0,1-.518-.518v-1.82a.518.518,0,0,1,.518-.518H70a.518.518,0,0,1,.518.518v1.82a.518.518,0,0,1-.518.518",
    transform: "translate(-0.125 -0.525)",
    fill: "#5d44ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_133",
    "data-name": "Path 133",
    d: "M86,70.291H78.449l-2.042-7.7a32.147,32.147,0,0,1-3.065-3.763,9.663,9.663,0,0,1-1.456-2.6c-.075-.459-.614-3.787-.729-4.495a.245.245,0,0,1,.064-.21.172.172,0,0,1,.031-.029c.238-.179.818-.418,1.477.719a7.938,7.938,0,0,1,.886,3.35l.269.454.736,1.241.919,1.549a3.115,3.115,0,0,0,1.647-.976l-.918-1.55-.736-1.24-.288-.489,0,0-1.975-2.779s-.972-.421-1.93-.873-1.265-2.023-.567-1.916a9.54,9.54,0,0,1,1.472.505c1.014.406,2.128.9,2.128.9a1.366,1.366,0,0,1,1.18-.169,1.95,1.95,0,0,1,1.043-.2,11.533,11.533,0,0,1,3.278,3.064c.376.743,1.257,7.733,1.257,7.733Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134",
    "data-name": "Path 134",
    d: "M71.768,49.548a.949.949,0,0,1-.125.377.312.312,0,0,1-.383.117l-.676-.278a.317.317,0,0,1-.193-.328.807.807,0,0,1,.116-.348.309.309,0,0,1,.363-.12l.69.241a.317.317,0,0,1,.208.339",
    fill: "#f0ebe9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_135",
    "data-name": "Path 135",
    d: "M72.05,52.726a.94.94,0,0,1-.608.148.124.124,0,0,1-.116-.1l-.158-.975a.125.125,0,0,1,.047-.118.755.755,0,0,1,.529-.135.127.127,0,0,1,.1.07,5,5,0,0,1,.249,1,.125.125,0,0,1-.044.116",
    fill: "#f0ebe9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_136",
    "data-name": "Path 136",
    d: "M75.532,55.036a3.125,3.125,0,0,1-1.648.977l-.269-.454a7.966,7.966,0,0,0-.886-3.35c-.659-1.138-1.239-.9-1.477-.719a.14.14,0,0,0-.031.028l-1.978-3.339a1.886,1.886,0,0,0,.234.283l.019.018a.862.862,0,0,0,.1.083.371.371,0,0,0,.032.023.466.466,0,0,0,.06.035.325.325,0,0,0,.043.02l.045.016.041.009h0a.3.3,0,0,0,.043,0A.272.272,0,0,0,70,48.63a.5.5,0,0,0,.207-.481v-.017a.773.773,0,0,0-.008-.089v-.015c0-.013,0-.025-.006-.036v0a1.05,1.05,0,0,0-.031-.136l.013.013.009.011.014.015.061.058a.288.288,0,0,0,.032.029c.014.011.027.023.041.033l.011.009a.587.587,0,0,0,.051.036l.013.01a1,1,0,0,0,.091.05c.016.007.031.015.048.021a.474.474,0,0,0,.05.015.158.158,0,0,0,.048.01.3.3,0,0,0,.134-.007.2.2,0,0,0,.039-.013.265.265,0,0,0,.041-.021.242.242,0,0,0,.085-.086.138.138,0,0,0,.014-.024h0a.318.318,0,0,0,.02-.051l0-.012a.174.174,0,0,0,.011-.045A.32.32,0,0,0,71,47.851v-.009a.907.907,0,0,0,0-.117l0-.045a1.406,1.406,0,0,0-.021-.147.355.355,0,0,0-.01-.047c0-.022-.009-.044-.014-.065s-.011-.043-.017-.063a1.817,1.817,0,0,0-.056-.174l1.361,2.3a9.574,9.574,0,0,0-1.471-.505c-.7-.107-.392,1.464.566,1.916s1.93.873,1.93.873l1.976,2.779,0,.005Z",
    fill: "#e9f0f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137",
    "data-name": "Path 137",
    d: "M76.268,56.276a3.117,3.117,0,0,1-1.648.977l-.735-1.24a3.125,3.125,0,0,0,1.648-.977Z",
    fill: "#c7c7c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138",
    "data-name": "Path 138",
    d: "M77.186,57.826a3.121,3.121,0,0,1-1.647.977l-.919-1.55a3.117,3.117,0,0,0,1.648-.977Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_139",
    "data-name": "Path 139",
    d: "M71,47.725a.909.909,0,0,1,0,.117v.009a.515.515,0,0,1-.007.053l0,.014,0,.014-.005.017,0,.012a.45.45,0,0,1-.02.051h0a.188.188,0,0,1-.014.024.25.25,0,0,1-.085.086.4.4,0,0,1-.041.021.268.268,0,0,1-.04.013.331.331,0,0,1-.133.007c-.015,0-.032-.006-.049-.01a.466.466,0,0,1-.049-.016.344.344,0,0,1-.049-.021.975.975,0,0,1-.09-.049l-.013-.01a.587.587,0,0,1-.051-.036l-.011-.009c-.014-.01-.028-.022-.041-.033l-.032-.029-.062-.058a.064.064,0,0,0-.013-.015l-.01-.011-.012-.013a1.277,1.277,0,0,1,.031.136v0a.27.27,0,0,0,.006.036v.014c0,.028.006.058.008.09v.016A.506.506,0,0,1,70,48.63a.276.276,0,0,1-.139.039.215.215,0,0,1-.043,0h0a.315.315,0,0,1-.042-.009.38.38,0,0,1-.044-.015.325.325,0,0,1-.043-.02.52.52,0,0,1-.06-.035.371.371,0,0,1-.032-.023.8.8,0,0,1-.1-.083l-.018-.019a1.841,1.841,0,0,1-.234-.282l-.014-.022-.32-1.641a1.346,1.346,0,0,0,.573-.538l1.395,1.2v0c.006.016.031.082.056.174.005.02.011.041.016.063s.01.043.015.065a.355.355,0,0,1,.01.047A1.406,1.406,0,0,1,71,47.68l0,.045",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140",
    "data-name": "Path 140",
    d: "M69.483,45.978a1.352,1.352,0,0,1-.573.538l-.114-.584.265-.319Z",
    fill: "#605e5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_141",
    "data-name": "Path 141",
    d: "M78.449,70.355a.063.063,0,0,1-.061-.047l-2.039-7.685a31.892,31.892,0,0,1-3.061-3.761c-.172-.273-.325-.514-.462-.729a5.993,5.993,0,0,1-1-1.9c-.075-.459-.614-3.787-.729-4.5a.309.309,0,0,1,.081-.264.214.214,0,0,1,.04-.036.752.752,0,0,1,.61-.15,1.634,1.634,0,0,1,.959.889,7.956,7.956,0,0,1,.894,3.363l1.892,3.191a3.094,3.094,0,0,0,1.538-.912L75.189,54.58l-1.966-2.764c-.132-.058-1.035-.452-1.916-.867a1.761,1.761,0,0,1-.952-1.767.357.357,0,0,1,.423-.27,9.135,9.135,0,0,1,1.485.509c.9.36,1.892.8,2.094.89a1.408,1.408,0,0,1,1.184-.162,1.972,1.972,0,0,1,1.059-.195c.58.086,2.963,2.379,3.326,3.1a77.526,77.526,0,0,1,1.261,7.742l4.868,9.467a.065.065,0,0,1-.028.086.064.064,0,0,1-.086-.028l-4.872-9.476a.081.081,0,0,1-.007-.022c-.008-.069-.883-6.987-1.25-7.712a11.45,11.45,0,0,0-3.231-3.03,1.882,1.882,0,0,0-1,.193.065.065,0,0,1-.049,0,1.312,1.312,0,0,0-1.118.155.063.063,0,0,1-.069.011c-.011-.005-1.125-.5-2.126-.9a9.23,9.23,0,0,0-1.458-.5.231.231,0,0,0-.282.181,1.647,1.647,0,0,0,.886,1.615c.946.446,1.918.868,1.928.872a.062.062,0,0,1,.027.021l1.975,2.779.006.009,1.943,3.279a.065.065,0,0,1-.006.073,3.151,3.151,0,0,1-1.684,1,.062.062,0,0,1-.067-.03l-1.923-3.244a.053.053,0,0,1-.009-.03,7.847,7.847,0,0,0-.878-3.321c-.283-.488-.577-.767-.874-.827a.63.63,0,0,0-.51.128.065.065,0,0,0-.019.017.183.183,0,0,0-.051.159c.115.71.654,4.037.729,4.5a5.981,5.981,0,0,0,.984,1.852c.137.215.291.456.463.729a32.247,32.247,0,0,0,3.057,3.754.065.065,0,0,1,.015.027l2.043,7.7a.064.064,0,0,1-.046.078l-.016,0",
    fill: "#605e5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_142",
    "data-name": "Path 142",
    d: "M74.619,57.316a.066.066,0,0,1-.055-.031l-1-1.695a.075.075,0,0,1-.009-.03,7.835,7.835,0,0,0-.877-3.32c-.284-.489-.578-.768-.874-.828a.63.63,0,0,0-.51.128.124.124,0,0,0-.02.018.064.064,0,0,1-.1-.008l-1.978-3.339a.064.064,0,0,1,.021-.086.063.063,0,0,1,.087.018,1.815,1.815,0,0,0,.225.272l.02.02a.741.741,0,0,0,.091.075.122.122,0,0,0,.023.016l.009.007a.334.334,0,0,0,.052.03.252.252,0,0,0,.038.018l.039.014.031.006h.005a.215.215,0,0,0,.14-.027.433.433,0,0,0,.176-.425v-.017a.661.661,0,0,0-.007-.081v-.017l-.005-.029V48h0a.977.977,0,0,0-.026-.117l0-.015a.064.064,0,0,1,.032-.07.065.065,0,0,1,.076.012l.015.017.007.007c.008.007.013.014.018.019l.054.051a.2.2,0,0,0,.029.026l.012.011.025.02.009.007a.454.454,0,0,0,.051.036l.018.014a.875.875,0,0,0,.078.042l.008,0a.306.306,0,0,0,.034.014.252.252,0,0,0,.045.014.13.13,0,0,0,.037.009.277.277,0,0,0,.113,0l.032-.01a.268.268,0,0,0,.033-.018A.178.178,0,0,0,70.887,48l.01-.015,0,0a.316.316,0,0,0,.016-.043l0-.016,0-.013,0-.007,0-.009,0-.008c0-.012,0-.027,0-.042v-.01a.774.774,0,0,0,0-.108l0-.044a1.245,1.245,0,0,0-.019-.138c0-.018-.006-.031-.009-.043s-.01-.047-.015-.066-.011-.043-.016-.063c-.024-.087-.048-.151-.054-.167a.064.064,0,0,1,.031-.081.063.063,0,0,1,.083.025l1.361,2.3a.065.065,0,0,1-.006.074.062.062,0,0,1-.072.017,9.23,9.23,0,0,0-1.458-.5.231.231,0,0,0-.282.181,1.645,1.645,0,0,0,.886,1.615c.946.446,1.918.868,1.928.872a.056.056,0,0,1,.026.022l1.976,2.779.006.008,1.024,1.729a.063.063,0,0,1-.006.073,3.15,3.15,0,0,1-1.685,1h-.012m-.941-1.777.973,1.641a3.09,3.09,0,0,0,1.538-.911l-1-1.69-1.965-2.764c-.132-.057-1.035-.452-1.916-.867a1.763,1.763,0,0,1-.953-1.767.356.356,0,0,1,.423-.269,7.9,7.9,0,0,1,1.312.439L71.051,47.6c0,.023.006.048.008.074l0,.046a1.055,1.055,0,0,1,0,.127l0,.014a.5.5,0,0,1-.007.054l0,.009a.244.244,0,0,1-.006.026l0,.018v0c-.008.025-.015.043-.022.06l0,.009a.338.338,0,0,1-.019.032.288.288,0,0,1-.1.1.324.324,0,0,1-.049.025.311.311,0,0,1-.049.016.377.377,0,0,1-.158.008.209.209,0,0,1-.061-.013c-.015,0-.033-.009-.052-.016a.364.364,0,0,1-.044-.019c-.036-.017-.067-.034-.1-.056l-.018-.013c-.015-.01-.034-.023-.053-.038l-.011-.009-.027-.022a.68.68,0,0,1,.007.085l0,.023a.553.553,0,0,1-.239.536.335.335,0,0,1-.22.044h-.006l-.048-.01-.051-.018a.382.382,0,0,1-.051-.023.526.526,0,0,1-.065-.039l-.005,0,1.649,2.786a.743.743,0,0,1,.588-.133,1.628,1.628,0,0,1,.959.888,7.956,7.956,0,0,1,.894,3.363",
    fill: "#605e5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143",
    "data-name": "Path 143",
    d: "M75.539,58.866a.065.065,0,0,1-.055-.032l-.919-1.549a.065.065,0,0,1,.043-.1,3.064,3.064,0,0,0,1.611-.955.064.064,0,0,1,.054-.022.063.063,0,0,1,.049.031l.919,1.55a.065.065,0,0,1-.006.073,3.167,3.167,0,0,1-1.684,1h-.012m-.82-1.571.851,1.435a3.094,3.094,0,0,0,1.538-.912l-.85-1.434a3.173,3.173,0,0,1-1.539.911",
    fill: "#605e5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_144",
    "data-name": "Path 144",
    d: "M69.863,48.732a.391.391,0,0,1-.049,0h-.006a.371.371,0,0,1-.048-.01.506.506,0,0,1-.051-.017l-.051-.024a.406.406,0,0,1-.065-.038l-.009-.006a.17.17,0,0,1-.03-.023.76.76,0,0,1-.1-.083l-.02-.02a1.914,1.914,0,0,1-.241-.292l-.014-.021a.071.071,0,0,1-.011-.025l-.433-2.225a.067.067,0,0,1,.014-.053l.264-.319a.063.063,0,0,1,.044-.022.067.067,0,0,1,.047.015l1.817,1.567a.083.083,0,0,1,.02.032c.012.031.034.095.057.177l.017.065c0,.021.01.044.015.068a.27.27,0,0,1,.01.051,1.3,1.3,0,0,1,.021.149l0,.046v0a1.045,1.045,0,0,1,0,.126l0,.014a.5.5,0,0,1-.007.054l0,.009a.244.244,0,0,1-.006.026l0,.017v.005c-.008.025-.015.043-.022.06l0,.008a.26.26,0,0,1-.019.033.3.3,0,0,1-.1.1c-.016.009-.033.018-.049.025a.312.312,0,0,1-.049.016.394.394,0,0,1-.158.008c-.017,0-.037-.006-.056-.011s-.038-.011-.057-.018-.028-.012-.044-.019a.982.982,0,0,1-.1-.057l-.018-.013a.448.448,0,0,1-.052-.038l-.012-.009c-.009-.006-.018-.014-.027-.021a.664.664,0,0,1,.007.085l0,.022a.555.555,0,0,1-.239.537.329.329,0,0,1-.171.047m-.039-.13h.005a.214.214,0,0,0,.141-.028.432.432,0,0,0,.175-.424v-.017a.661.661,0,0,0-.007-.081v-.017l-.005-.03V48a.925.925,0,0,0-.027-.117l0-.015a.064.064,0,0,1,.108-.058l.015.017.008.007a.146.146,0,0,1,.017.019l.054.051c.011.01.02.019.029.026l.012.01.025.02.009.008c.021.016.035.026.051.036l.018.013a.694.694,0,0,0,.078.043l.009,0,.033.014a.439.439,0,0,0,.045.014l.042.009a.257.257,0,0,0,.108-.005.173.173,0,0,0,.032-.011.258.258,0,0,0,.033-.017.178.178,0,0,0,.062-.063l.01-.016,0,0a.316.316,0,0,0,.016-.043l0-.016,0-.013v-.007l0-.009,0-.008c0-.012,0-.027,0-.042v-.01a.774.774,0,0,0,0-.108l0-.044a1.3,1.3,0,0,0-.019-.139c0-.018-.006-.03-.009-.043s-.01-.046-.015-.066-.011-.043-.016-.062c-.021-.074-.041-.131-.05-.157L69.068,45.7l-.2.245.425,2.184.008.013a1.965,1.965,0,0,0,.224.27l.02.019a.659.659,0,0,0,.091.075.142.142,0,0,0,.023.017l.009.007a.538.538,0,0,0,.052.03.418.418,0,0,0,.039.018.243.243,0,0,0,.038.013l.031.007",
    fill: "#605e5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_145",
    "data-name": "Path 145",
    d: "M70.768,49.039A.064.064,0,0,1,70.711,49L70.2,47.98a.064.064,0,1,1,.114-.057l.509,1.024a.063.063,0,0,1-.029.085.058.058,0,0,1-.028.007",
    fill: "#605e5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_146",
    "data-name": "Path 146",
    d: "M74.853,55.679a.065.065,0,0,1-.054-.03L73.533,53.6a.064.064,0,1,1,.108-.067l1.266,2.053a.064.064,0,0,1-.021.088.066.066,0,0,1-.033.009",
    fill: "#605e5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_147",
    "data-name": "Path 147",
    d: "M77.186,53.625a.064.064,0,0,1-.048-.021l-2.817-3.177a.063.063,0,0,1,0-.09.064.064,0,0,1,.09,0l2.818,3.177a.064.064,0,0,1-.006.09.061.061,0,0,1-.042.016",
    fill: "#605e5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_148",
    "data-name": "Path 148",
    d: "M78.193,52.686a.06.06,0,0,1-.043-.017l-2.645-2.4a.064.064,0,0,1,.086-.094l2.645,2.405a.063.063,0,0,1,0,.09.062.062,0,0,1-.047.021",
    fill: "#605e5b"
  })))), /*#__PURE__*/React.createElement("text", {
    id: "Hotel",
    transform: "translate(526 522)",
    fill: "#fff",
    fontSize: 3,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "HOTEL")), /*#__PURE__*/React.createElement("text", {
    id: "Check-In",
    transform: "translate(551 521)",
    fill: "#fff",
    fontSize: 2,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Check-In"))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeyondStayCheckin);
export default __webpack_public_path__ + "static/media/beyondStay-checkin.b9e479c71025b3f5bac03fa58c1286a1.svg";
export { ForwardRef as ReactComponent };